import axios from 'axios'
import { put, call, take, fork } from 'redux-saga/effects'

import {
  FETCH_QUESTION,
  FETCH_QUESTION_SUCCESS,
  FETCH_QUESTION_FAILURE,
  POST_ANSWER,
  POST_ANSWER_SUCCESS,
  POST_ANSWER_FAILURE,
  FETCH_QUIZ_RESULT,
  FETCH_QUIZ_RESULT_SUCCESS,
  FETCH_QUIZ_RESULT_FAILURE
} from '../actions/questionActions'
import { SHOW_MODAL_ERROR, SHOW_ERROR_POPUP } from '../actions/noticeActions'

export function* runFetchQuestionHandler() {
  while (true) {
    yield take([`${FETCH_QUESTION}`])
    yield fork(fetchQuestionHandler)
  }
}

function* fetchQuestionHandler() {
  const { data, error } = yield call(fetchQuestion)
  if (error != null) {
    yield put(FETCH_QUESTION_FAILURE())
    yield put(SHOW_MODAL_ERROR(error.message))
    return
  }
  yield put(FETCH_QUESTION_SUCCESS(data))
}

const fetchQuestion = () => {
  return axios
    .get('/api/v1/participants/questions')
    .then(function(response) {
      return { data: response.data }
    })
    .catch(function(error) {
      return { error: error }
    })
}

export function* runPostAnswerHandler() {
  while (true) {
    const { payload } = yield take([`${POST_ANSWER}`])
    yield fork(postAnswerHandler, payload)
  }
}

function* postAnswerHandler(payload) {
  const { data, error } = yield call(postAnswer, payload)
  if (error != null) {
    yield put(POST_ANSWER_FAILURE())
    yield put(SHOW_ERROR_POPUP(error.message))
    return
  }
  yield put(POST_ANSWER_SUCCESS(data))
}

const postAnswer = data => {
  return axios
    .post(`/api/v1/participants/questions/${data.questionId}/answers`, {
      choiceId: data.choiceId
    })
    .then(function(response) {
      return { data: response.data }
    })
    .catch(function(error) {
      return { error: error.response.data }
    })
}

export function* runFetchQuizResultHandler() {
  while (true) {
    yield take([`${FETCH_QUIZ_RESULT}`])
    yield fork(fetchQuizResultHandler)
  }
}

function* fetchQuizResultHandler() {
  const { data, error } = yield call(fetchQuizResult)
  if (error != null) {
    yield put(FETCH_QUIZ_RESULT_FAILURE())
    yield put(SHOW_MODAL_ERROR(error.message))
    return
  }
  yield put(FETCH_QUIZ_RESULT_SUCCESS(data))
}

const fetchQuizResult = () => {
  return axios
    .get('/api/v1/participants/projects/result')
    .then(function(response) {
      return { data: response.data }
    })
    .catch(function(error) {
      return { error: error.response.data }
    })
}
